import { render, staticRenderFns } from "./TeamPermissionManager.vue?vue&type=template&id=59e51a84&scoped=true&lang=pug&"
import script from "./TeamPermissionManager.vue?vue&type=script&lang=js&"
export * from "./TeamPermissionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e51a84",
  null
  
)

export default component.exports